import { styled, XStack } from 'tamagui';

export const IconContainer = styled(XStack, {
  name: 'IconContainer',
  backgroundColor: '$transparentBorder',
  padding: 0,
  width: 64,
  height: 64,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 36,
});
